import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useWizard } from 'react-use-wizard';
import FurtherAssistanceContact from '../FurtherAssistanceContact';
import { ScheduleStepProgress } from '../ScheduleStepProgress';
import StepTitle from '../StepTitle/StepTitle';
import { getStepConfiguration } from '../templates/ScheduleLayout/ScheduleLayout.helpers';
import { usePatientInformationStore } from '@src/store';
export interface IWizardContent {
  children: ReactNode;
}
const WizardContent: React.FC<IWizardContent> = ({
  children
}) => {
  const {
    t
  } = useTranslation('index');
  const theme = useTheme();
  const {
    activeStep
  } = useWizard();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const {
    firstName
  } = usePatientInformationStore();
  const steps = isSmallScreen ? getStepConfiguration('mobile') : getStepConfiguration('desktop');
  return <Stack direction="row" p={{
    md: 5,
    xs: 0,
    xl: '2% 15%',
    l: '2% 10%'
  }} bgcolor="backgrounds.neutral" spacing={2.5} justifyContent="center" data-sentry-element="Stack" data-sentry-component="WizardContent" data-sentry-source-file="WizardContent.tsx">
			<Stack direction="row" spacing={2.5} width="100%" maxWidth="75rem" data-sentry-element="Stack" data-sentry-source-file="WizardContent.tsx">
				{!isSmallScreen && <ScheduleStepProgress steps={steps} currentStep={activeStep} />}
				<Box width="100%" sx={{
        pt: {
          xs: '4rem',
          md: 0
        },
        flex: 1,
        display: 'flex',
        flexDirection: 'column'
      }} data-sentry-element="Box" data-sentry-source-file="WizardContent.tsx">
					<Box width="100%" bgcolor="#FFFFFF" p={{
          md: 5,
          xs: 2.5
        }} borderRadius={2} sx={{
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: 'neutrals.primary'
        }} data-sentry-element="Box" data-sentry-source-file="WizardContent.tsx">
						<StepTitle title={activeStep !== 3 ? t('threeSteps') : `${t('allSet')} ${firstName}!`} subTitle={steps[activeStep]?.subtitleKey && t(steps[activeStep].subtitleKey)} data-sentry-element="StepTitle" data-sentry-source-file="WizardContent.tsx" />
						{children}
					</Box>
					{!isSmallScreen && <Box mt={3.5}>
							<FurtherAssistanceContact />
						</Box>}
				</Box>
			</Stack>
		</Stack>;
};
export default WizardContent;